var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4209_1893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.6913 28.9855H66.0037L60.1606 42.2778M44.9902 38.3547H36.6431C36.6431 38.3547 41.0625 30.3441 41.7919 29.4492C42.5294 28.5444 43.2277 29.1088 43.2942 29.9069C43.3608 30.705 43.2609 42.2778 43.2609 42.2778M34.4817 42.3772C34.4817 42.3772 28.0145 42.4584 27.7081 42.3564C27.4019 42.2542 28.1992 41.7148 32.4394 35.6566C33.2313 34.5252 33.6672 33.5706 33.8525 32.7709L33.9183 32.2567C33.9183 30.3783 32.3955 28.8555 30.517 28.8555C28.8641 28.8555 27.4866 30.0345 27.1797 31.5975M54.1411 28.9855L48.8027 42.4078",
    stroke: "#753E0B",
    strokeWidth: 2.34375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.8058 43.5827C1.9933 39.5053 0.86393 35.2113 1.24612 31.172C1.34127 30.1673 1.80643 29.2336 2.52002 28.5202L8.40768 22.6325C10.0924 20.9478 12.8799 21.1506 14.3028 23.0616L20.9531 31.902C21.2966 32.3586 21.4615 32.925 21.4167 33.4946C21.3719 34.0642 21.1206 34.5978 20.71 34.9952L16.4022 39.1641C16.1456 39.4124 15.9817 39.7412 15.938 40.0957C15.8943 40.4502 15.9734 40.8089 16.1621 41.1122V41.1123C21.8955 50.3302 29.6717 58.1064 38.8896 63.8398C39.1928 64.0284 39.5516 64.1075 39.906 64.0638C40.2605 64.0201 40.5893 63.8563 40.8377 63.5997L45.0064 59.2919C45.4038 58.8813 45.9375 58.63 46.5071 58.5853C47.0767 58.5405 47.6431 58.7053 48.0997 59.0488L56.9402 65.6991C58.8511 67.122 59.0539 69.9095 57.3692 71.5942L51.4816 77.4819C50.7418 78.2203 49.7658 78.6747 48.7246 78.7655C34.5357 80.015 17.2613 62.7408 17.2613 62.7408C17.2613 62.7408 10.978 56.4575 6.2644 48.3572",
    stroke: "#753E0B",
    strokeWidth: 2.34375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8888 13.861C36.3591 3.57878 54.0028 3.94987 65.0273 14.9744C76.4361 26.3832 76.4361 44.8802 65.0273 56.2889C61.8472 59.4691 58.1164 61.7627 54.1417 63.1699M16.7969 25.9591C17.8554 22.934 19.4079 20.1052 21.3912 17.5877",
    stroke: "#753E0B",
    strokeWidth: 2.34375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3016 12.937C82.1698 26.4723 81.6477 47.0832 68.735 59.9957C65.677 63.0537 62.1872 65.4168 58.4619 67.0849M12.9375 21.4866C14.6044 17.7805 16.9598 14.3085 20.0039 11.2645C32.7687 -1.50039 53.057 -2.1568 66.5956 9.29555",
    stroke: "#753E0B",
    strokeWidth: 2.34375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4209_1893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport1);
export default __webpack_public_path__ + "static/media/support1.060512153bdabd04e6de53f96434c820.svg";
export { ForwardRef as ReactComponent };